import { combineReducers } from 'redux'
import numbers from './numbers'

const bingoReducers = combineReducers({
    numbers
});

export default bingoReducers